/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
// Action key prefix for order integrations
export const ORDER_INTEGRATION_ACTION_PREFIX = 'order/integration/';
